import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import EmailPreferencesPage from "@/pages/EmailPreferencesPage";

export const Route = createFileRoute("/email-preferences")({
  head: () => pageHead("Email Preferences | AKIVA", "Manage your AKIVA newsletter preferences", "/email-preferences", true),
  component: EmailPreferencesPage,
});
